import { QuotaStatusResponse } from '@reach/interfaces/quotas/quota.responses';

import {
	ClientQuota,
	ClientQuotaBreakdown,
	ClientQuotaItem,
	ClientQuotaItemData,
	ClientQuotaKey,
} from '../types/quota.type';

const ALL_STANDARD_KEYS = Object.values(ClientQuotaKey) as ClientQuotaKey[];

export function quotaCalculations(
	quota: Pick<ClientQuotaItemData, 'total' | 'used'>
): Pick<ClientQuotaItemData, 'percentage' | 'showWarning'> {
	const percentage = (quota.used / quota.total) * 100;
	const showWarning = percentage >= 90;
	return {
		percentage,
		showWarning,
	};
}

export const transformApiToClientQuota = (apiQuota: QuotaStatusResponse): ClientQuota => {
	const quota: ClientQuota = {
		standard: ALL_STANDARD_KEYS.reduce(
			(acc, key) => {
				const value = apiQuota[key];

				if (!value) {
					throw new Error(`Missing quota data for key: ${key}`);
				}

				const item: ClientQuotaItem = {
					key: key,
					data: {
						used: value.used,
						total: value.total,
						available: value.available,
						percentage: 0,
						showWarning: false,
						breakdown: (value.breakdown ?? null) as ClientQuotaBreakdown,
					},
				};

				const calculation = quotaCalculations(item.data);

				item.data.percentage = calculation.percentage;
				item.data.showWarning = calculation.showWarning;

				acc[key] = item;

				return acc;
			},
			{} as ClientQuota['standard']
		),
	};

	return quota;
};
